import { render, staticRenderFns } from "./ProjectViewTypeSelector.vue?vue&type=template&id=73af9024&"
import script from "./ProjectViewTypeSelector.vue?vue&type=script&lang=ts&"
export * from "./ProjectViewTypeSelector.vue?vue&type=script&lang=ts&"
import style0 from "./ProjectViewTypeSelector.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports